export const env = {
  ADMIN_ROUTE: process.env.NEXT_PUBLIC_ADMIN_ROUTE || '', // Previously using ADMIN2_URI
  ANALYZE: process.env.ANALYZE || '',
  API_URI: process.env.NEXT_PUBLIC_API_URI,
  BASE_PATH: process.env.NEXT_PUBLIC_BASE_PATH,
  DEFAULT_PORTAL: process.env.NEXT_PUBLIC_DEFAULT_PORTAL,
  DOMAIN: process.env.NEXT_PUBLIC_DOMAIN || '',
  GENERIC_PORTAL_HOSTS: (
    process.env.NEXT_PUBLIC_GENERIC_PORTAL_HOSTS ||
    'my.getambassador.com,my-ca.getambassador.com,my.getambassador.co,my.dev.getambassador.com'
  )
    .split(',')
    .map((h) => h.trim().toLowerCase())
    .filter(Boolean),
  NODE_ENV: process.env.NODE_ENV ?? 'development',
  PROTOCOL_CHECK: process.env.NEXT_PUBLIC_PROTOCOL_CHECK,
  PROTOCOL_HOST_CHECK: process.env.NEXT_PUBLIC_PROTOCOL_HOST_CHECK === 'true',
  RECAPTCHA_V3_SECRETKEY: process.env.RECAPTCHA_V3_SECRETKEY,
  RECAPTCHA_V3_SITEKEY: process.env.NEXT_PUBLIC_RECAPTCHA_V3_SITEKEY || '',
  S3_BUCKET: process.env.NEXT_PUBLIC_S3_BUCKET || '',
  SEGMENT_KEY: process.env.NEXT_PUBLIC_SEGMENT_KEY,
  SNIPPET_DOMAIN: process.env.NEXT_PUBLIC_SNIPPET_DOMAIN,
  TANGO_IMG_SOURCE: process.env.NEXT_PUBLIC_TANGO_IMG_SOURCE || '',
  WIDGETS_DOMAIN: process.env.NEXT_PUBLIC_WIDGETS_DOMAIN,
  REDIS_URL: process.env.REDIS_URL,

  // COMPUTED VALUES
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  SHOULD_ANALYZE_BUNDLE: process.env.ANALYZE === 'true',
} as const;

export type Env = typeof env;

export const {
  ADMIN_ROUTE,
  ANALYZE,
  API_URI,
  BASE_PATH,
  DEFAULT_PORTAL,
  DOMAIN,
  GENERIC_PORTAL_HOSTS,
  NODE_ENV,
  PROTOCOL_CHECK,
  PROTOCOL_HOST_CHECK,
  RECAPTCHA_V3_SECRETKEY,
  RECAPTCHA_V3_SITEKEY,
  S3_BUCKET,
  SEGMENT_KEY,
  SNIPPET_DOMAIN,
  TANGO_IMG_SOURCE,
  WIDGETS_DOMAIN,
  REDIS_URL,

  IS_PRODUCTION,
  IS_DEVELOPMENT,
  SHOULD_ANALYZE_BUNDLE,
} = env;
